function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "193pt",
    height: "193pt",
    viewBox: "0 0 193 193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 0.242188 L 192.757813 0.242188 L 192.757813 193 L 0 193 L 0 0.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 35.230469 128.246094 C 35.402344 128.640625 35.601563 129.089844 35.601563 129.089844 C 37.046875 132.378906 38.96875 135.992188 42.320313 138.835938 C 42.257813 138.992188 42.195313 139.152344 42.132813 139.308594 C 40.402344 143.667969 37.503906 150.96875 41.265625 159.359375 L 41.285156 159.347656 C 41.335938 159.480469 41.378906 159.613281 41.441406 159.753906 L 41.617188 160.148438 L 41.796875 160.542969 L 42.054688 160.890625 L 42.15625 161.027344 C 43.632813 163.792969 45.660156 165.882813 48.097656 167.167969 C 48.839844 168.886719 49.785156 170.460938 50.921875 171.855469 L 50.941406 171.839844 C 51.019531 171.953125 51.09375 172.0625 51.1875 172.179688 L 51.449219 172.503906 L 51.976563 173.148438 L 52.503906 173.796875 L 53.25 174.167969 L 53.996094 174.542969 L 54.742188 174.914063 C 54.949219 175.019531 55.167969 175.117188 55.394531 175.210938 C 58.804688 180.078125 64.261719 183.269531 70.597656 184.199219 L 70.597656 184.332031 C 70.597656 184.335938 71.597656 184.375 72.5625 184.414063 C 73.09375 184.453125 73.632813 184.476563 74.175781 184.480469 C 74.269531 184.484375 74.324219 184.488281 74.324219 184.488281 L 74.445313 184.492188 C 74.453125 184.492188 74.5 184.492188 74.535156 184.488281 C 74.554688 184.492188 74.59375 184.492188 74.625 184.492188 C 74.734375 184.496094 74.886719 184.5 75.0625 184.496094 L 78.894531 184.410156 L 78.890625 184.15625 C 81.199219 183.738281 83.347656 182.90625 85.316406 181.667969 L 86.777344 181.417969 C 91.414063 180.621094 95.433594 178.429688 98.785156 174.894531 C 99.339844 175.324219 99.902344 175.746094 100.484375 176.132813 L 100.914063 176.421875 L 101.347656 176.710938 L 101.78125 176.996094 L 102.273438 177.160156 L 102.769531 177.328125 L 103.261719 177.492188 C 109.960938 179.722656 115.839844 177.421875 118.667969 176.316406 L 118.671875 176.316406 L 118.773438 176.277344 L 118.984375 176.195313 L 119.046875 176.167969 L 119.050781 176.167969 L 119.425781 176.019531 C 119.425781 176.019531 119.453125 175.992188 119.488281 175.957031 C 122.4375 174.542969 125.183594 172.445313 127.554688 169.835938 C 128.59375 169.949219 129.644531 169.976563 130.699219 169.90625 C 130.742188 169.90625 130.777344 169.90625 130.894531 169.898438 C 130.9375 169.894531 130.976563 169.898438 131.019531 169.894531 L 130.894531 169.898438 C 131.210938 169.878906 132.117188 169.800781 135.421875 169.527344 L 139.820313 169.160156 L 144.222656 168.796875 L 143.296875 164.476563 L 141.445313 155.84375 C 141.4375 155.800781 141.425781 155.765625 141.414063 155.722656 C 144.34375 152.3125 146.609375 148.941406 148.417969 145.332031 C 149.914063 144.941406 151.847656 144.347656 154.378906 143.570313 C 154.378906 143.570313 161.394531 141.410156 161.394531 141.410156 L 168.410156 139.253906 L 156.949219 130.082031 C 156.949219 130.082031 156.039063 129.355469 155.140625 128.632813 C 156.507813 123.296875 157.113281 117.761719 156.917969 112.367188 L 161.984375 109.957031 C 161.984375 109.957031 172.585938 104.976563 178.519531 102.1875 C 171.003906 99.285156 155.066406 93.128906 152.820313 92.226563 C 151.1875 87.371094 148.660156 82.597656 145.410156 78.234375 C 145.527344 77.710938 145.636719 77.199219 145.722656 76.699219 L 145.773438 76.382813 L 146.535156 71.808594 L 147.351563 66.917969 L 148.105469 62.410156 C 148.140625 62.304688 148.183594 62.199219 148.214844 62.089844 L 148.1875 62.082031 C 148.265625 61.898438 148.339844 61.710938 148.410156 61.503906 L 148.601563 60.914063 L 148.792969 60.328125 L 148.792969 58.472656 C 148.792969 58.421875 148.796875 58.246094 148.800781 58.15625 C 149.054688 48.703125 143.589844 45.085938 140.304688 43.773438 L 140.382813 43.808594 C 140.152344 43.710938 139.621094 43.5 138.136719 42.90625 L 133.800781 41.171875 L 132.015625 42.679688 L 130.234375 44.1875 C 130.234375 44.1875 128.449219 45.695313 128.449219 45.695313 C 128.078125 46.011719 127.410156 46.046875 127.140625 46.046875 L 126.035156 46.046875 C 125.117188 45.480469 124.148438 45.027344 123.144531 44.679688 C 122.992188 44.375 122.820313 44.050781 122.628906 43.714844 C 124.699219 35.332031 123.0625 25.878906 118.273438 19.039063 L 118.277344 19.035156 L 118.21875 18.945313 C 118.199219 18.921875 118.175781 18.886719 118.15625 18.859375 L 118.144531 18.835938 L 118.121094 18.808594 L 118.097656 18.769531 C 118.050781 18.699219 117.988281 18.613281 117.988281 18.613281 L 117.984375 18.617188 C 115.390625 14.710938 111.746094 11.75 107.40625 10.050781 C 107.433594 10.0625 107.183594 9.964844 107.183594 9.964844 C 107.1875 9.964844 106.96875 9.878906 106.96875 9.878906 L 106.75 9.792969 L 106.296875 9.675781 L 106.066406 9.617188 C 98.867188 7.761719 91.195313 8.90625 84.621094 12.730469 C 82.164063 11.355469 79.320313 10.804688 76.464844 11.210938 L 76.46875 11.230469 C 76.402344 11.238281 76.335938 11.238281 76.265625 11.246094 C 72.984375 10.261719 69.511719 10.445313 66.347656 11.800781 L 66.347656 11.796875 L 66.261719 11.832031 L 66.261719 11.835938 C 62.472656 13.417969 59.484375 16.609375 57.933594 20.671875 C 57.007813 21.441406 56.199219 22.3125 55.535156 23.289063 C 54.796875 24.363281 54.242188 25.535156 53.871094 26.765625 C 53.445313 26.886719 53.089844 27.011719 52.761719 27.132813 C 52.734375 27.144531 52.683594 27.160156 52.660156 27.167969 C 52.449219 27.234375 52.117188 27.339844 51.996094 27.367188 C 51.957031 27.378906 51.871094 27.394531 51.871094 27.394531 C 51.871094 27.394531 51.726563 27.425781 51.726563 27.425781 L 51.578125 27.457031 L 51.4375 27.5 L 51.292969 27.539063 C 51.292969 27.539063 51.148438 27.582031 51.148438 27.582031 C 28.480469 35.203125 31.304688 57.808594 31.304688 57.808594 C 33.523438 75.164063 44.605469 77.160156 44.625 77.183594 C 44.625 77.183594 33.679688 82.484375 39.351563 93.261719 C 39.195313 93.417969 39.042969 93.574219 38.910156 93.710938 C 36.097656 96.539063 30.867188 101.804688 31.542969 110.355469 L 31.53125 110.066406 C 31.53125 110.171875 31.53125 110.207031 31.542969 110.363281 C 31.542969 110.367188 31.542969 110.371094 31.542969 110.375 L 31.542969 110.363281 C 31.546875 110.398438 31.550781 110.441406 31.554688 110.492188 L 31.363281 110.917969 L 31.058594 111.597656 L 31.066406 111.601563 C 31.039063 111.660156 31.007813 111.714844 30.980469 111.777344 C 30.980469 111.773438 30.90625 111.945313 30.90625 111.945313 C 30.824219 112.128906 30.789063 112.230469 30.707031 112.476563 C 30.707031 112.476563 30.648438 112.65625 30.648438 112.65625 C 29.328125 116.621094 29.097656 122.484375 35.230469 128.246094 Z M 31.363281 110.921875 L 31.441406 110.957031 C 31.429688 110.976563 31.414063 111 31.402344 111.023438 L 31.363281 110.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.199097%,30.999756%,63.09967%)",
      fillOpacity: 1
    },
    d: "M 38.292969 125.769531 L 38.375 125.953125 L 38.996094 127.367188 C 40.617188 131.046875 42.679688 134.78125 46.757813 137.199219 C 46.566406 138.105469 46.089844 139.308594 45.582031 140.585938 C 43.980469 144.621094 41.558594 150.71875 44.648438 157.613281 L 44.828125 158.007813 L 45.003906 158.402344 L 45.25 158.730469 C 46.621094 161.457031 48.621094 163.316406 50.976563 164.125 C 51.632813 166.042969 52.566406 167.761719 53.773438 169.242188 L 54.828125 170.539063 L 55.574219 170.910156 L 56.320313 171.285156 C 56.773438 171.511719 57.261719 171.679688 57.765625 171.824219 C 60.949219 177.152344 67.191406 180.449219 74.324219 180.445313 L 74.324219 180.449219 C 74.335938 180.449219 74.347656 180.445313 74.363281 180.449219 C 74.515625 180.449219 74.664063 180.457031 74.820313 180.453125 L 74.820313 180.449219 C 78.167969 180.496094 81.15625 179.621094 83.722656 177.816406 L 85.964844 177.429688 C 91.949219 176.402344 95.734375 172.695313 98.195313 169.09375 C 99.464844 170.457031 100.894531 171.6875 102.480469 172.742188 C 102.480469 172.742188 102.910156 173.03125 102.910156 173.03125 L 103.34375 173.320313 L 103.839844 173.484375 L 104.332031 173.648438 C 109.695313 175.4375 114.507813 173.550781 117.09375 172.542969 L 117.222656 172.492188 L 117.347656 172.441406 L 117.472656 172.382813 L 117.59375 172.324219 C 120.6875 170.855469 123.582031 168.4375 125.863281 165.476563 C 127.351563 165.855469 128.9375 165.996094 130.539063 165.863281 L 134.9375 165.5 L 139.339844 165.132813 L 138.414063 160.816406 L 137.488281 156.496094 C 137.34375 155.808594 137.144531 155.183594 136.921875 154.605469 C 140.746094 150.425781 143.453125 146.433594 145.472656 142.011719 C 145.667969 141.957031 145.871094 141.917969 146.0625 141.855469 C 146.0625 141.855469 153.078125 139.699219 153.078125 139.699219 L 160.09375 137.539063 L 154.363281 132.953125 L 150.546875 129.902344 C 152.5625 123.328125 153.304688 116.46875 152.726563 109.828125 C 155.652344 108.433594 160.15625 106.289063 160.15625 106.289063 L 168.15625 102.480469 C 168.15625 102.480469 159.933594 99.179688 159.933594 99.179688 L 149.519531 94.988281 C 147.894531 89.359375 144.980469 83.859375 141.007813 78.921875 C 141.320313 77.902344 141.566406 76.894531 141.730469 75.902344 L 143.363281 66.121094 L 141.265625 66.28125 C 142.554688 64.753906 143.644531 62.9375 144.367188 60.726563 L 144.558594 60.140625 L 144.75 59.550781 L 144.75 58.316406 C 144.75 58.214844 144.753906 58.050781 144.757813 57.890625 C 144.941406 51.148438 141.566406 48.367188 138.703125 47.21875 L 134.367188 45.484375 L 132.582031 46.992188 L 130.800781 48.503906 C 129.558594 49.550781 128.039063 49.769531 126.980469 49.769531 L 124.804688 49.769531 C 124.589844 49.628906 124.367188 49.496094 124.140625 49.367188 C 122.914063 48.558594 121.5625 48.019531 120.140625 47.765625 C 119.808594 46.886719 119.289063 45.542969 118.257813 44.210938 C 120.710938 36.523438 119.414063 27.3125 114.769531 20.859375 C 112.613281 17.496094 109.527344 14.953125 105.832031 13.507813 L 105.394531 13.335938 L 105.167969 13.277344 L 104.9375 13.21875 C 97.953125 11.421875 90.351563 12.972656 84.34375 17.253906 C 82.378906 15.421875 79.640625 14.5 76.855469 14.894531 L 76.160156 14.996094 L 75.851563 15.097656 C 73.175781 14.046875 70.269531 14.09375 67.660156 15.234375 C 64.464844 16.570313 62.101563 19.355469 61.0625 22.890625 C 60.078125 23.550781 59.226563 24.378906 58.578125 25.324219 C 57.625 26.714844 57.121094 28.285156 57.0625 29.898438 C 35.945313 31.574219 35.542969 54.78125 35.542969 54.78125 C 37.15625 76.578125 53.234375 75.046875 53.300781 75.292969 C 52.941406 75.28125 37.085938 81.453125 43.191406 94.308594 C 42.765625 94.929688 42.320313 95.464844 41.503906 96.289063 C 38.800781 99.011719 34.714844 103.125 35.257813 109.90625 C 35.257813 109.90625 35.300781 110.46875 35.34375 111.019531 C 35.136719 111.476563 34.933594 111.921875 34.753906 112.332031 C 34.753906 112.328125 34.449219 113.015625 34.449219 113.015625 C 34.449219 113.015625 34.371094 113.195313 34.371094 113.195313 L 34.292969 113.363281 C 34.292969 113.367188 34.234375 113.546875 34.234375 113.546875 L 34.175781 113.722656 C 32.726563 118.070313 34.117188 122.121094 38.292969 125.769531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.199585%,71.398926%,72.198486%)",
      fillOpacity: 1
    },
    d: "M 132.085938 100.835938 C 130.335938 91.972656 125.371094 86.96875 118.691406 81.292969 C 114.570313 77.789063 117.59375 74.929688 118.683594 70.402344 C 121.496094 70.140625 123.871094 68.921875 126.472656 67.867188 C 130.523438 66.222656 134.527344 64.820313 136.027344 60.273438 C 138.035156 54.183594 135.441406 51.941406 129.304688 53.875 C 126.523438 54.75 123.875 55.183594 120.894531 54.503906 C 117.128906 53.644531 115.433594 53.253906 111.585938 55.421875 C 108.050781 57.410156 106.144531 61.539063 104.425781 65.019531 C 102.488281 68.945313 99.710938 70.765625 95.578125 72.554688 C 93.039063 73.65625 90.1875 74.484375 87.660156 75.296875 C 81.902344 77.152344 76.355469 78.53125 70.425781 79.449219 C 63.746094 80.480469 42.183594 79.191406 46.792969 92.0625 C 47.925781 95.21875 49.644531 94.414063 47.523438 97.230469 C 46.320313 98.832031 44.792969 100.109375 43.585938 101.742188 C 40.5 105.914063 41.414063 109.324219 40.027344 113.730469 C 39.414063 115.675781 38.539063 117.351563 39.300781 119.617188 C 40.105469 122.007813 41.554688 122.128906 42.9375 124.058594 C 44.425781 126.125 44.902344 128.269531 47.136719 130.222656 C 50.988281 133.585938 54.003906 131.984375 52.34375 137.867188 C 51.121094 142.1875 48.976563 146.328125 49.074219 150.921875 C 49.148438 154.257813 49.980469 155.449219 52.644531 157.152344 C 53.542969 157.726563 54.761719 157.839844 55.480469 158.746094 C 56.269531 159.734375 56.089844 161.734375 57.003906 162.894531 C 58.429688 164.703125 60.609375 165.785156 62.082031 167.398438 C 64.175781 169.695313 65.972656 171.542969 68.808594 172.832031 C 75.179688 175.722656 78.65625 172.640625 84.007813 170.21875 C 90.296875 167.367188 93.996094 164.5625 97.664063 158.398438 C 100.09375 160.710938 100.933594 162.929688 104.375 164.511719 C 117.222656 170.414063 124.425781 157.230469 126.789063 146.074219 C 128.375 138.578125 126.773438 129.425781 129.105469 122.410156 C 131.632813 114.816406 133.722656 109.117188 132.085938 100.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 119.601563 73.929688 C 124.257813 75.679688 128.714844 73.867188 133.113281 72.679688 C 134.191406 74.941406 132.5625 77.453125 133.589844 80.070313 C 134.730469 82.960938 137.195313 85.394531 138.945313 87.945313 C 140.878906 90.765625 141.863281 93.738281 142.585938 97.078125 C 143.246094 100.132813 144.625 103.566406 145.1875 106.628906 C 146.277344 112.550781 144.511719 120.847656 143.617188 126.71875 C 142.765625 132.304688 140.820313 139.296875 137.652344 144.113281 C 135.851563 146.851563 129.917969 150.71875 126.425781 150.210938 C 128.589844 145.804688 128.632813 136.890625 128.324219 132.175781 C 128.109375 128.910156 127.378906 126.882813 128.910156 123.734375 C 130.257813 120.964844 131.839844 118.785156 132.457031 115.65625 C 133.554688 110.09375 132.519531 103.65625 131.640625 98.195313 C 130.953125 93.941406 127.027344 89.480469 124.066406 86.3125 C 121.167969 83.210938 111.863281 78.03125 119.277344 73.929688 L 119.601563 73.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 57.164063 72.636719 C 59.890625 77.953125 60.832031 80.703125 67.90625 80.398438 C 74.113281 80.136719 80.371094 78.574219 86.367188 76.84375 C 91.179688 75.453125 96.539063 73.460938 100.511719 70.363281 C 102.808594 68.574219 103.039063 66.113281 104.636719 63.921875 C 106.378906 61.53125 109.089844 60.097656 110.78125 57.683594 C 112.972656 54.566406 114.171875 44.457031 107.855469 48.617188 C 104.328125 50.941406 101.070313 54.441406 97.277344 56.785156 C 87.503906 62.820313 76.820313 67.214844 65.582031 69.410156 C 63.066406 69.902344 57.765625 69.160156 57.164063 72.3125 L 57.164063 72.636719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.558594 88.71875 C 88.558594 91.980469 85.828125 94.625 82.460938 94.625 C 79.09375 94.625 76.363281 91.980469 76.363281 88.71875 C 76.363281 85.453125 79.09375 82.804688 82.460938 82.804688 C 85.828125 82.804688 88.558594 85.453125 88.558594 88.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 87.242188 88.289063 C 87.242188 91.164063 84.910156 93.496094 82.035156 93.496094 C 79.164063 93.496094 76.835938 91.164063 76.835938 88.289063 C 76.835938 85.417969 79.164063 83.089844 82.035156 83.089844 C 84.910156 83.089844 87.242188 85.417969 87.242188 88.289063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 86.886719 80.210938 C 86.886719 80.210938 94.738281 79.640625 94.457031 87.683594 C 94.457031 87.683594 97.765625 84.371094 94.835938 80.398438 C 94.835938 80.398438 91.238281 77.183594 86.886719 80.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 67.5625 84.03125 C 67.5625 84.03125 59.144531 96.425781 72.957031 86.964844 C 86.769531 77.507813 91.121094 83.371094 91.121094 83.371094 C 91.121094 83.371094 85.539063 80.34375 70.210938 92.453125 C 70.210938 92.453125 60.65625 98.792969 62.832031 89.710938 C 62.832031 89.710938 64.15625 85.832031 67.5625 84.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 111.644531 107.585938 C 111.644531 107.585938 121.742188 113.429688 119.21875 129.734375 C 119.21875 129.734375 129.03125 116.460938 111.644531 107.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 85.804688 103.605469 C 85.804688 103.605469 112.898438 99.121094 108.039063 116.777344 C 108.039063 116.777344 108.316406 106.597656 85.804688 103.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 82.347656 105.382813 C 82.347656 105.382813 98.511719 81.652344 111.871094 105.476563 C 111.871094 105.476563 110.28125 91.367188 98.230469 91.367188 C 86.179688 91.367188 82.347656 105.382813 82.347656 105.382813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 58.828125 96.839844 C 58.828125 96.839844 65.511719 97.121094 68.605469 97.753906 C 71.699219 98.386719 80.566406 98.597656 88.867188 93.109375 C 88.867188 93.109375 80.988281 98.246094 78.3125 103.453125 C 78.3125 103.453125 72.753906 98.527344 58.828125 96.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 68.746094 102.957031 C 68.746094 102.957031 51.929688 105.070313 52.425781 118.226563 C 52.425781 118.226563 41.609375 107.078125 49.890625 100.707031 C 58.125 94.375 68.746094 102.957031 68.746094 102.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.609375 107.882813 C 49.609375 107.882813 47.429688 99.933594 56.855469 101.269531 C 56.855469 101.269531 51.160156 102.675781 49.609375 107.882813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 46.234375 107.882813 C 46.234375 107.882813 38.144531 116.113281 41.730469 119.351563 C 45.316406 122.585938 48.976563 121.390625 52.214844 119.28125 C 52.214844 119.28125 43.773438 129.972656 38.144531 122.796875 C 38.144531 122.796875 33.21875 114.847656 46.234375 107.882813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 46.9375 113.265625 C 46.9375 113.867188 46.449219 114.355469 45.84375 114.355469 C 45.242188 114.355469 44.757813 113.867188 44.757813 113.265625 C 44.757813 112.664063 45.242188 112.175781 45.84375 112.175781 C 46.449219 112.175781 46.9375 112.664063 46.9375 113.265625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 48.289063 117.425781 C 48.289063 118.121094 47.726563 118.679688 47.035156 118.679688 C 46.34375 118.679688 45.78125 118.121094 45.78125 117.425781 C 45.78125 116.734375 46.34375 116.171875 47.035156 116.171875 C 47.726563 116.171875 48.289063 116.734375 48.289063 117.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 44.683594 116.183594 C 44.683594 116.613281 44.339844 116.957031 43.910156 116.957031 C 43.484375 116.957031 43.140625 116.613281 43.140625 116.183594 C 43.140625 115.757813 43.484375 115.414063 43.910156 115.414063 C 44.339844 115.414063 44.683594 115.757813 44.683594 116.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 69.875 113.757813 C 69.875 114.710938 69.105469 115.480469 68.152344 115.480469 C 67.195313 115.480469 66.425781 114.710938 66.425781 113.757813 C 66.425781 112.800781 67.195313 112.03125 68.152344 112.03125 C 69.105469 112.03125 69.875 112.800781 69.875 113.757813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 64.875 109.113281 C 64.875 109.871094 64.261719 110.484375 63.507813 110.484375 C 62.746094 110.484375 62.132813 109.871094 62.132813 109.113281 C 62.132813 108.355469 62.746094 107.742188 63.507813 107.742188 C 64.261719 107.742188 64.875 108.355469 64.875 109.113281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 62.414063 115.519531 C 62.414063 116.3125 61.769531 116.957031 60.972656 116.957031 C 60.175781 116.957031 59.53125 116.3125 59.53125 115.519531 C 59.53125 114.722656 60.175781 114.074219 60.972656 114.074219 C 61.769531 114.074219 62.414063 114.722656 62.414063 115.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 111.457031 61.511719 C 111.457031 61.511719 116.660156 73.527344 130.28125 64.632813 C 130.28125 64.632813 133.875 62.839844 135.203125 57.917969 C 135.203125 57.917969 136.714844 51.957031 131.226563 55.835938 C 131.226563 55.835938 125.929688 58.960938 124.039063 57.632813 L 122.144531 54.132813 C 122.144531 54.132813 126.6875 53.851563 130.566406 50.820313 C 134.445313 47.796875 142.582031 53.378906 137.945313 61.796875 C 137.945313 61.796875 132.648438 71.257813 120.726563 71.164063 C 120.726563 71.164063 108.804688 69.742188 111.457031 61.511719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 107.199219 80.621094 C 107.199219 80.621094 108.902344 68.796875 112.023438 65.296875 L 114.578125 67.285156 L 117.511719 68.417969 L 121.199219 69.460938 C 121.199219 69.460938 116.5625 80.246094 116.941406 88.097656 C 116.941406 88.097656 113.726563 81.570313 115.523438 73.527344 C 115.523438 73.527344 116.5625 68.703125 112.589844 70.5 C 112.589844 70.5 109.65625 72.582031 107.199219 80.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 90.792969 103.871094 C 90.792969 103.871094 68.976563 128.320313 52.214844 119.28125 L 49.992188 121.085938 L 42.523438 124.308594 C 42.523438 124.308594 42.210938 130.207031 51.171875 135.707031 C 51.171875 135.707031 47.164063 149.308594 47.792969 153.082031 C 48.421875 156.855469 49.363281 159.84375 55.261719 161.808594 L 56.753906 161.179688 L 56.28125 157.71875 L 55.261719 156.855469 C 55.261719 156.855469 49.679688 158.113281 51.640625 147.5 C 51.640625 147.5 54.394531 137.28125 55.808594 135.472656 C 55.808594 135.472656 59.582031 127.21875 58.089844 123.289063 C 58.089844 123.289063 63.589844 124.152344 65.476563 123.050781 C 67.363281 121.953125 89.21875 113.304688 90.792969 103.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 45.738281 124.839844 C 45.738281 124.839844 48.132813 122.023438 51.085938 122.515625 C 51.085938 122.515625 50.527344 128.988281 52.074219 130.746094 C 52.074219 130.746094 47.570313 131.027344 45.738281 124.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 61.863281 157.953125 C 61.863281 157.953125 61.546875 168.726563 71.058594 172.261719 C 80.570313 175.800781 86.230469 162.4375 86.703125 159.765625 C 86.703125 159.765625 85.683594 180.832031 70.351563 176.507813 C 70.351563 176.507813 58.484375 174.699219 61.863281 157.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 96.519531 127.722656 C 96.519531 127.722656 97.164063 130.742188 96.519531 133.003906 C 95.871094 135.269531 93.179688 165.03125 104.390625 168.699219 C 115.605469 172.367188 121.324219 165.679688 126.820313 154.464844 C 132.320313 143.25 131.457031 121.792969 128.332031 116.078125 C 128.332031 116.078125 123.371094 105.292969 116.578125 102.597656 C 116.578125 102.597656 128.65625 113.703125 126.714844 140.125 C 126.714844 140.125 124.988281 158.023438 113.882813 162.875 C 113.882813 162.875 105.148438 167.730469 101.265625 159.316406 C 101.265625 159.316406 96.628906 146.59375 96.519531 127.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 94.09375 104.183594 L 90.792969 103.871094 L 89.21875 106.308594 C 89.21875 106.308594 73.734375 122.265625 61.390625 122.894531 C 61.390625 122.894531 69.722656 134.058594 62.019531 144.589844 C 62.019531 144.589844 57.933594 143.804688 57.070313 138.378906 C 57.070313 138.378906 51.484375 143.492188 55.886719 152.453125 C 55.886719 152.453125 51.25 165.660156 61.628906 168.566406 L 63.121094 167.546875 L 62.492188 164.796875 C 62.492188 164.796875 55.496094 164.796875 57.933594 153.945313 C 57.933594 153.945313 60.210938 155.753906 62.570313 153.867188 C 62.570313 153.867188 68.390625 165.503906 81.203125 157.246094 C 81.203125 157.246094 90.636719 157.878906 88.828125 149.390625 C 88.828125 149.390625 95.824219 135 96.53125 129.417969 C 96.53125 129.417969 96.59375 129.566406 96.6875 129.828125 C 96.679688 129.972656 96.667969 130.117188 96.652344 130.265625 C 96.554688 130.996094 96.539063 131.78125 96.503906 132.515625 C 96.480469 132.976563 96.535156 133.441406 96.484375 133.902344 C 96.40625 134.609375 96.332031 135.316406 96.304688 136.03125 C 96.273438 136.914063 96.339844 137.8125 96.433594 138.6875 C 96.480469 139.109375 96.484375 139.601563 96.785156 139.929688 C 96.5 144.785156 96.808594 152.074219 96.6875 154.8125 C 96.6875 154.8125 95.429688 158.582031 94.566406 159.683594 C 93.699219 160.785156 89.847656 169.039063 83.875 169.121094 L 81.28125 171.871094 C 81.28125 171.871094 83.558594 173.835938 88.589844 171.320313 C 93.621094 168.804688 100.066406 164.085938 99.597656 151.273438 C 99.597656 151.273438 99.203125 134.527344 99.832031 131.464844 C 99.832031 131.464844 101.71875 123.914063 94.09375 104.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 68.464844 122.585938 C 68.464844 122.585938 72.542969 121.8125 73.882813 120.335938 C 73.882813 120.335938 73.460938 126.949219 76.132813 129.058594 C 76.132813 129.058594 69.945313 129.339844 68.464844 122.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 76.976563 143.621094 C 76.976563 143.621094 76.976563 151.492188 81.546875 154.597656 C 81.546875 154.597656 85.832031 155.175781 86.546875 150.121094 C 86.546875 150.121094 80.117188 151.417969 76.976563 143.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.808594 141.863281 C 56.808594 141.863281 55.308594 149.621094 58.234375 151.707031 C 58.234375 151.707031 62.585938 153.359375 63.257813 148.832031 C 63.257813 148.832031 58.085938 146.175781 56.808594 141.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.89856%,10.598755%,17.599487%)",
      fillOpacity: 1
    },
    d: "M 90.765625 124.839844 C 84.921875 127.589844 81.902344 134.617188 81.902344 134.617188 C 81.902344 134.617188 81.058594 131.660156 85.210938 125.117188 C 85.210938 125.117188 75.78125 128.777344 66.847656 144.816406 C 66.847656 144.816406 59.742188 160.929688 77.679688 154.3125 C 77.679688 154.3125 72.753906 146.152344 76.34375 139.472656 C 76.34375 139.472656 79.441406 146.859375 86.546875 147.421875 C 86.546875 147.421875 92.171875 138.414063 94.214844 127.019531 C 94.214844 127.019531 95.550781 122.585938 90.765625 124.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 54.675781 83.492188 C 54.675781 83.492188 49.261719 84.0625 48.789063 89.378906 C 48.3125 94.699219 56.101563 96.601563 56.957031 96.792969 C 56.957031 96.792969 42.230469 98.5 42.800781 110.28125 L 39.855469 113.417969 C 39.855469 113.417969 36.054688 104.582031 47.269531 96.316406 C 47.269531 96.316406 43.089844 92.421875 46.128906 85.675781 C 49.167969 78.929688 57.90625 79.5 58.574219 79.59375 C 58.574219 79.59375 79.855469 81.019531 103.414063 66.105469 L 101.898438 71.234375 C 101.898438 71.234375 85.269531 83.015625 54.675781 83.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 31.7032,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 1166.601563 1128.945313 C 1166.601563 1128.945313 1431.210938 974.179688 1291.953125 689.492188 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 38.0429,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 1180.546875 1193.90625 C 1180.546875 1193.90625 1446.5625 1164.570313 1455.976563 822.539063 C 1465.234375 485.234375 1248.632813 393.945313 1248.632813 393.945313 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 122.851563 74.074219 L 137.707031 68.035156 L 135.695313 82.890625 C 135.695313 82.890625 126.101563 75.15625 122.851563 74.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 144.050781 94.960938 L 158.75 100.84375 L 145.75 108.886719 Z M 144.050781 94.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 140.800781 138.441406 L 154.414063 136.121094 L 144.511719 126.0625 Z M 140.800781 138.441406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 136.621094 161.964844 L 131.050781 150.515625 L 125.324219 152.988281 L 121.304688 161.1875 L 136.621094 161.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 135.585938 71.3125 L 123.699219 77.941406 C 123.699219 77.941406 126.214844 83.199219 130.101563 82.972656 L 135.585938 71.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 19.0206,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 1355.859375 1216.875 L 1236.992188 1150.585938 C 1236.992188 1150.585938 1262.148438 1098.007813 1301.015625 1100.273438 Z M 1355.859375 1216.875 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 138.324219 98.058594 C 138.324219 98.058594 135.847656 103.007813 138.789063 107.339844 L 152.558594 101.925781 L 138.324219 98.058594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 19.0206,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 1383.242188 949.414063 C 1383.242188 949.414063 1358.476563 899.921875 1387.890625 856.601563 L 1525.585938 910.742188 Z M 1383.242188 949.414063 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 137.707031 125.601563 C 137.707031 125.601563 133.371094 129.15625 133.835938 134.417969 L 147.453125 133.957031 L 137.707031 125.601563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 19.0206,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 1377.070313 673.984375 C 1377.070313 673.984375 1333.710938 638.4375 1338.359375 585.820313 L 1474.53125 590.429688 Z M 1377.070313 673.984375 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 133.0625 159.484375 L 128.730469 150.515625 C 128.730469 150.515625 123.933594 153.761719 122.851563 158.09375 L 133.0625 159.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 19.0206,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 1330.625 335.15625 L 1287.304688 424.84375 C 1287.304688 424.84375 1239.335938 392.382813 1228.515625 349.0625 Z M 1330.625 335.15625 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 84.328125 87.492188 C 84.328125 88.507813 83.503906 89.335938 82.484375 89.335938 C 81.464844 89.335938 80.640625 88.507813 80.640625 87.492188 C 80.640625 86.472656 81.464844 85.644531 82.484375 85.644531 C 83.503906 85.644531 84.328125 86.472656 84.328125 87.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 54.574219 89.867188 C 53.941406 89.394531 53.382813 89.019531 52.878906 88.710938 C 51.730469 89.269531 50.9375 90.414063 50.9375 91.75 C 50.9375 93.625 52.503906 95.148438 54.441406 95.148438 C 56.121094 95.148438 57.519531 94.003906 57.863281 92.472656 C 57.851563 92.460938 57.84375 92.449219 57.84375 92.449219 L 54.574219 89.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 53.339844 89.003906 C 52.558594 89.484375 52.039063 90.34375 52.039063 91.328125 C 52.039063 92.839844 53.265625 94.070313 54.777344 94.070313 C 56.019531 94.070313 57.070313 93.238281 57.40625 92.101563 L 54.574219 89.867188 C 54.132813 89.535156 53.722656 89.25 53.339844 89.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.929688 91.34375 C 55.929688 91.792969 55.566406 92.15625 55.113281 92.15625 C 54.664063 92.15625 54.300781 91.792969 54.300781 91.34375 C 54.300781 90.894531 54.664063 90.53125 55.113281 90.53125 C 55.566406 90.53125 55.929688 90.894531 55.929688 91.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 48.726563 90.644531 C 48.726563 90.644531 46.808594 84.539063 54.289063 90.097656 L 57.648438 92.773438 C 57.648438 92.773438 59.160156 94.625 61.011719 89.820313 C 61.011719 89.820313 62.523438 85.5 64.101563 84.265625 C 64.101563 84.265625 61.011719 86.046875 59.296875 88.3125 C 57.582031 90.578125 54.972656 90.027344 53.328125 87.285156 C 51.679688 84.539063 52.296875 83.714844 54.90625 83.304688 L 49.210938 84.128906 L 47.425781 89.34375 L 48.726563 90.644531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 59.445313 71.777344 C 59.445313 71.777344 60.167969 77.320313 64.023438 79.609375 L 61.855469 81.417969 L 59.082031 80.453125 L 58.238281 79.488281 C 58.238281 79.488281 55.828125 75.753906 55.585938 72.257813 L 56.082031 71.066406 L 58.484375 70.445313 L 59.445313 71.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 109.558594 48.5 C 109.558594 48.5 112.472656 49.964844 112.261719 53.519531 L 113.507813 54.09375 L 114.859375 53.554688 L 115.304688 51.167969 C 115.304688 51.167969 115.023438 48.320313 111.832031 45.636719 L 110.777344 45.523438 L 109.3125 47.53125 L 109.558594 48.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 60.746094 34.109375 C 60.746094 34.109375 42.425781 33.871094 41.125 52.550781 C 39.824219 71.230469 56.019531 72.058594 56.019531 72.058594 L 58.738281 70.519531 L 75.996094 67.210938 L 93.613281 59.644531 L 108.152344 48.410156 L 111.460938 46.285156 C 111.460938 46.285156 119.738281 34.582031 107.679688 20.871094 C 107.679688 20.871094 97.15625 10.703125 82.144531 24.890625 L 60.746094 34.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 56.136719 72.292969 C 56.136719 72.292969 57.085938 54.796875 77.296875 45.105469 C 97.511719 35.410156 110.867188 47.113281 110.867188 47.113281 C 110.867188 47.113281 95.382813 69.21875 56.136719 72.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.199097%,30.999756%,63.09967%)",
      fillOpacity: 1
    },
    d: "M 60.070313 68.316406 C 60.070313 68.316406 61.742188 54.898438 78.835938 47.46875 C 95.925781 40.039063 106.851563 47.230469 106.851563 47.230469 C 106.851563 47.230469 93.019531 63.546875 60.070313 68.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 84.035156 29.855469 C 84.035156 29.855469 83.5625 20.515625 99.757813 21.34375 C 99.757813 21.34375 115.125 24.179688 108.507813 44.628906 C 108.507813 44.628906 108.269531 45.457031 106.378906 44.039063 C 106.378906 44.039063 108.859375 27.609375 99.640625 24.652344 C 90.417969 21.695313 84.035156 29.855469 84.035156 29.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 87.9375 28.671875 C 87.9375 28.671875 93.019531 26.542969 94.085938 26.898438 C 95.148438 27.253906 104.253906 36.472656 102.949219 42.738281 L 98.8125 41.4375 C 98.8125 41.4375 98.101563 30.917969 87.9375 28.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.199097%,30.999756%,63.09967%)",
      fillOpacity: 1
    },
    d: "M 97.632813 27.253906 C 97.632813 27.253906 102.714844 26.898438 104.253906 35.289063 C 104.253906 35.289063 101.886719 30.328125 97.632813 27.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.199097%,30.999756%,63.09967%)",
      fillOpacity: 1
    },
    d: "M 86.046875 30.679688 C 86.046875 30.679688 93.492188 30.328125 97.039063 41.085938 L 95.503906 40.964844 C 95.503906 40.964844 92.429688 33.28125 86.046875 30.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.199097%,30.999756%,63.09967%)",
      fillOpacity: 1
    },
    d: "M 80.84375 37.300781 C 80.84375 37.300781 83.917969 37.183594 85.808594 42.148438 L 83.445313 42.621094 C 83.445313 42.621094 83.5625 39.902344 80.84375 37.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.199097%,30.999756%,63.09967%)",
      fillOpacity: 1
    },
    d: "M 72.804688 47.347656 C 72.804688 47.347656 70.207031 40.019531 71.503906 36.59375 C 71.503906 36.59375 67.132813 43.449219 69.613281 49.832031 L 72.804688 47.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 61.339844 42.265625 C 61.339844 42.265625 60.511719 44.984375 60.628906 45.339844 C 60.628906 45.339844 56.371094 51.84375 61.574219 57.988281 L 59.683594 61.300781 C 59.683594 61.300781 49.753906 51.015625 61.339844 42.265625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.199097%,30.999756%,63.09967%)",
      fillOpacity: 1
    },
    d: "M 58.621094 41.203125 C 58.621094 41.203125 49.519531 48.53125 55.308594 59.644531 C 55.308594 59.644531 46.324219 48.886719 58.621094 41.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 61.695313 39.191406 L 60.15625 36.828125 C 60.15625 36.828125 44.789063 38.246094 45.734375 53.023438 C 46.679688 67.800781 56.847656 68.511719 56.847656 68.511719 L 57.675781 66.144531 C 57.675781 66.144531 49.691406 63.644531 50.046875 50.636719 C 50.046875 50.636719 50.582031 41.910156 61.695313 39.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 74.34375 33.871094 C 74.34375 33.871094 73.515625 43.328125 75.644531 45.929688 C 75.644531 45.929688 77.53125 44.15625 80.609375 43.566406 C 80.609375 43.566406 80.726563 38.957031 74.34375 33.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 74.171875 25.152344 C 75.121094 27.75 74.183594 30.484375 72.070313 31.261719 C 69.957031 32.035156 67.46875 30.5625 66.515625 27.964844 C 65.5625 25.367188 66.503906 22.632813 68.617188 21.855469 C 70.730469 21.082031 73.214844 22.554688 74.171875 25.152344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 50.7255,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 741.71875 1678.476563 C 751.25 1652.5 741.835938 1625.15625 720.703125 1617.382813 C 699.570313 1609.648438 674.6875 1624.375 665.15625 1650.351563 C 655.625 1676.328125 665.039063 1703.671875 686.171875 1711.445313 C 707.304688 1719.179688 732.148438 1704.453125 741.71875 1678.476563 Z M 741.71875 1678.476563 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 66.789063 30.984375 C 66.789063 32.109375 65.875 33.023438 64.75 33.023438 C 63.625 33.023438 62.714844 32.109375 62.714844 30.984375 C 62.714844 29.859375 63.625 28.945313 64.75 28.945313 C 65.875 28.945313 66.789063 29.859375 66.789063 30.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 50.7255,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 667.890625 1620.15625 C 667.890625 1608.90625 658.75 1599.765625 647.5 1599.765625 C 636.25 1599.765625 627.148438 1608.90625 627.148438 1620.15625 C 627.148438 1631.40625 636.25 1640.546875 647.5 1640.546875 C 658.75 1640.546875 667.890625 1631.40625 667.890625 1620.15625 Z M 667.890625 1620.15625 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 72.832031 35.816406 C 72.832031 37.289063 71.640625 38.480469 70.167969 38.480469 C 68.699219 38.480469 67.507813 37.289063 67.507813 35.816406 C 67.507813 34.347656 68.699219 33.15625 70.167969 33.15625 C 71.640625 33.15625 72.832031 34.347656 72.832031 35.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 50.7255,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 728.320313 1571.835938 C 728.320313 1557.109375 716.40625 1545.195313 701.679688 1545.195313 C 686.992188 1545.195313 675.078125 1557.109375 675.078125 1571.835938 C 675.078125 1586.523438 686.992188 1598.4375 701.679688 1598.4375 C 716.40625 1598.4375 728.320313 1586.523438 728.320313 1571.835938 Z M 728.320313 1571.835938 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 66.03125 36.226563 C 66.03125 37.382813 65.09375 38.320313 63.9375 38.320313 C 62.777344 38.320313 61.839844 37.382813 61.839844 36.226563 C 61.839844 35.066406 62.777344 34.128906 63.9375 34.128906 C 65.09375 34.128906 66.03125 35.066406 66.03125 36.226563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 50.7255,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 660.3125 1567.734375 C 660.3125 1556.171875 650.9375 1546.796875 639.375 1546.796875 C 627.773438 1546.796875 618.398438 1556.171875 618.398438 1567.734375 C 618.398438 1579.335938 627.773438 1588.710938 639.375 1588.710938 C 650.9375 1588.710938 660.3125 1579.335938 660.3125 1567.734375 Z M 660.3125 1567.734375 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 78.847656 24.402344 C 78.847656 25.464844 77.984375 26.324219 76.925781 26.324219 C 75.863281 26.324219 75.003906 25.464844 75.003906 24.402344 C 75.003906 23.34375 75.863281 22.480469 76.925781 22.480469 C 77.984375 22.480469 78.847656 23.34375 78.847656 24.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 50.7255,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 788.476563 1685.976563 C 788.476563 1675.351563 779.84375 1666.757813 769.257813 1666.757813 C 758.632813 1666.757813 750.039063 1675.351563 750.039063 1685.976563 C 750.039063 1696.5625 758.632813 1705.195313 769.257813 1705.195313 C 779.84375 1705.195313 788.476563 1696.5625 788.476563 1685.976563 Z M 788.476563 1685.976563 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 74.179688 32.382813 C 74.179688 33.820313 75.34375 34.988281 76.78125 34.988281 C 78.222656 34.988281 79.386719 33.820313 79.386719 32.382813 C 79.386719 30.945313 78.222656 29.777344 76.78125 29.777344 C 75.34375 29.777344 74.179688 30.945313 74.179688 32.382813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 50.7255,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 741.796875 1606.171875 C 741.796875 1591.796875 753.4375 1580.117188 767.8125 1580.117188 C 782.226563 1580.117188 793.867188 1591.796875 793.867188 1606.171875 C 793.867188 1620.546875 782.226563 1632.226563 767.8125 1632.226563 C 753.4375 1632.226563 741.796875 1620.546875 741.796875 1606.171875 Z M 741.796875 1606.171875 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 82.085938 28.070313 C 82.085938 29.152344 81.207031 30.03125 80.128906 30.03125 C 79.046875 30.03125 78.167969 29.152344 78.167969 28.070313 C 78.167969 26.992188 79.046875 26.113281 80.128906 26.113281 C 81.207031 26.113281 82.085938 26.992188 82.085938 28.070313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 50.7255,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(13.699341%,12.199402%,12.5%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.6131
    },
    d: "M 820.859375 1649.296875 C 820.859375 1638.476563 812.070313 1629.6875 801.289063 1629.6875 C 790.46875 1629.6875 781.679688 1638.476563 781.679688 1649.296875 C 781.679688 1660.078125 790.46875 1668.867188 801.289063 1668.867188 C 812.070313 1668.867188 820.859375 1660.078125 820.859375 1649.296875 Z M 820.859375 1649.296875 ",
    transform: "matrix(0.1,0,0,-0.1,0,193)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 74.171875 25.152344 C 75.121094 27.75 74.183594 30.484375 72.070313 31.261719 C 69.957031 32.035156 67.46875 30.5625 66.515625 27.964844 C 65.5625 25.367188 66.503906 22.632813 68.617188 21.855469 C 70.730469 21.082031 73.214844 22.554688 74.171875 25.152344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 66.789063 30.984375 C 66.789063 32.109375 65.875 33.023438 64.75 33.023438 C 63.625 33.023438 62.714844 32.109375 62.714844 30.984375 C 62.714844 29.859375 63.625 28.945313 64.75 28.945313 C 65.875 28.945313 66.789063 29.859375 66.789063 30.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 72.832031 35.816406 C 72.832031 37.289063 71.640625 38.480469 70.167969 38.480469 C 68.699219 38.480469 67.507813 37.289063 67.507813 35.816406 C 67.507813 34.347656 68.699219 33.15625 70.167969 33.15625 C 71.640625 33.15625 72.832031 34.347656 72.832031 35.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 66.03125 36.226563 C 66.03125 37.382813 65.09375 38.320313 63.9375 38.320313 C 62.777344 38.320313 61.839844 37.382813 61.839844 36.226563 C 61.839844 35.066406 62.777344 34.128906 63.9375 34.128906 C 65.09375 34.128906 66.03125 35.066406 66.03125 36.226563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 78.847656 24.402344 C 78.847656 25.464844 77.984375 26.324219 76.925781 26.324219 C 75.863281 26.324219 75.003906 25.464844 75.003906 24.402344 C 75.003906 23.34375 75.863281 22.480469 76.925781 22.480469 C 77.984375 22.480469 78.847656 23.34375 78.847656 24.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 74.179688 32.382813 C 74.179688 33.820313 75.34375 34.988281 76.78125 34.988281 C 78.222656 34.988281 79.386719 33.820313 79.386719 32.382813 C 79.386719 30.945313 78.222656 29.777344 76.78125 29.777344 C 75.34375 29.777344 74.179688 30.945313 74.179688 32.382813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 82.085938 28.070313 C 82.085938 29.152344 81.207031 30.03125 80.128906 30.03125 C 79.046875 30.03125 78.167969 29.152344 78.167969 28.070313 C 78.167969 26.992188 79.046875 26.113281 80.128906 26.113281 C 81.207031 26.113281 82.085938 26.992188 82.085938 28.070313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 70.042969 52.492188 C 70.042969 52.492188 72.703125 61.597656 77.667969 64.554688 L 77.296875 65.671875 L 70.796875 68.628906 L 68.3125 66.855469 C 68.3125 66.855469 64.765625 63.308594 63.46875 60.117188 C 62.164063 56.925781 63.585938 56.925781 63.585938 56.925781 L 68.90625 52.316406 L 70.042969 52.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 67.132813 41.320313 C 67.132813 41.320313 63.230469 39.074219 62.402344 44.628906 C 62.402344 44.628906 61.21875 54.207031 68.550781 64.136719 C 68.550781 64.136719 70.796875 68.15625 74.933594 65.082031 C 74.933594 65.082031 65.003906 54.207031 67.132813 41.320313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 86.992188 44.867188 C 86.992188 44.867188 89.347656 51.339844 87.933594 61.03125 L 89.945313 60.589844 L 98.339844 56.097656 L 99.046875 53.851563 C 99.046875 53.851563 98.21875 46.050781 96.921875 44.277344 L 95.976563 42.976563 L 88.527344 43.210938 L 86.992188 44.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.699585%,61.999512%,5.499268%)",
      fillOpacity: 1
    },
    d: "M 82.027344 35.054688 C 82.027344 35.054688 80.964844 32.691406 83.800781 31.628906 C 83.800781 31.628906 95.503906 34.347656 96.210938 55.152344 C 96.210938 55.152344 93.847656 57.871094 92.074219 57.632813 C 92.074219 57.632813 92.785156 39.308594 82.027344 35.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 69.820313 74.066406 L 63.949219 75.203125 L 63.539063 73.074219 L 69.40625 71.9375 L 69.820313 74.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 70.421875 77.183594 L 64.550781 78.320313 L 64.140625 76.1875 L 70.011719 75.054688 L 70.421875 77.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 78.953125 71.984375 L 73.152344 73.433594 L 72.628906 71.328125 L 78.429688 69.882813 L 78.953125 71.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 79.722656 75.0625 L 73.921875 76.511719 L 73.394531 74.40625 L 79.195313 72.960938 L 79.722656 75.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 88.050781 68.933594 L 82.46875 71.074219 L 81.691406 69.050781 L 87.273438 66.90625 L 88.050781 68.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 89.1875 71.894531 L 83.605469 74.035156 L 82.828125 72.011719 L 88.410156 69.871094 L 89.1875 71.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 96.054688 64.871094 L 90.777344 67.679688 L 89.757813 65.765625 L 95.039063 62.957031 L 96.054688 64.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 97.542969 67.675781 L 92.265625 70.480469 L 91.25 68.566406 L 96.53125 65.757813 L 97.542969 67.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 103.511719 59.867188 L 98.609375 63.296875 L 97.367188 61.519531 L 102.265625 58.089844 L 103.511719 59.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 105.328125 62.464844 L 100.433594 65.894531 L 99.1875 64.121094 L 104.085938 60.6875 L 105.328125 62.464844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 110.296875 53.988281 L 105.851563 57.992188 L 104.398438 56.378906 L 108.84375 52.378906 L 110.296875 53.988281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 100.953125 81.378906 C 100.953125 81.378906 101.617188 67.566406 111.929688 57.917969 C 111.929688 57.917969 120.253906 49.96875 124.132813 63.59375 C 124.132813 63.59375 129.148438 48.457031 115.335938 51.105469 C 115.335938 51.105469 98.589844 57.351563 100.953125 81.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 147.292969 153.855469 C 148.382813 153.855469 149.308594 154.238281 150.074219 155.007813 C 150.839844 155.773438 151.222656 156.695313 151.222656 157.78125 C 151.222656 158.871094 150.839844 159.800781 150.074219 160.570313 C 149.3125 161.339844 148.386719 161.722656 147.292969 161.722656 C 146.203125 161.722656 145.273438 161.339844 144.511719 160.570313 C 143.753906 159.800781 143.371094 158.871094 143.371094 157.78125 C 143.371094 156.695313 143.753906 155.773438 144.519531 155.007813 C 145.285156 154.238281 146.210938 153.855469 147.292969 153.855469 Z M 151.867188 157.773438 C 151.867188 156.515625 151.421875 155.445313 150.53125 154.554688 C 149.636719 153.667969 148.5625 153.226563 147.296875 153.226563 C 146.039063 153.226563 144.96875 153.667969 144.078125 154.554688 C 143.1875 155.445313 142.742188 156.519531 142.742188 157.773438 C 142.742188 159.039063 143.183594 160.121094 144.066406 161.011719 C 144.953125 161.90625 146.03125 162.351563 147.296875 162.351563 C 148.5625 162.351563 149.636719 161.90625 150.53125 161.011719 C 151.421875 160.117188 151.867188 159.035156 151.867188 157.773438 Z M 148.507813 156.800781 C 148.507813 157.179688 148.332031 157.4375 147.984375 157.570313 C 147.796875 157.644531 147.515625 157.679688 147.140625 157.679688 L 146.335938 157.679688 L 146.335938 155.894531 L 147.09375 155.894531 C 147.589844 155.894531 147.945313 155.953125 148.171875 156.074219 C 148.394531 156.199219 148.507813 156.441406 148.507813 156.800781 Z M 145.460938 155.265625 L 145.460938 160.265625 L 146.335938 160.265625 L 146.335938 158.308594 L 147.039063 158.308594 C 147.511719 158.308594 147.839844 158.363281 148.03125 158.46875 C 148.347656 158.65625 148.507813 159.035156 148.507813 159.609375 L 148.507813 160 L 148.523438 160.160156 C 148.527344 160.179688 148.53125 160.199219 148.535156 160.214844 C 148.539063 160.230469 148.546875 160.246094 148.550781 160.265625 L 149.367188 160.265625 L 149.339844 160.203125 C 149.316406 160.164063 149.304688 160.074219 149.296875 159.945313 C 149.289063 159.8125 149.285156 159.6875 149.285156 159.574219 L 149.285156 159.207031 C 149.285156 158.957031 149.191406 158.699219 149.011719 158.4375 C 148.828125 158.171875 148.542969 158.011719 148.148438 157.949219 C 148.460938 157.898438 148.703125 157.816406 148.878906 157.707031 C 149.203125 157.492188 149.367188 157.164063 149.367188 156.714844 C 149.367188 156.085938 149.105469 155.660156 148.589844 155.445313 C 148.296875 155.324219 147.839844 155.265625 147.214844 155.265625 L 145.460938 155.265625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9af06480e4c681e818dde8de512a6053.svg";
export { ForwardRef as ReactComponent };